import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  pageLink : string[] = []

  constructor() { }
  private isAuthenticated = false;

  userPermission(pages: any) {
    this.pageLink = this.extractPageLinks(pages);
    const pageLinkJSON = JSON.stringify(this.pageLink);
    // Store the JSON string in local storage
    localStorage.setItem("pageLinks", pageLinkJSON);
    // Recursive function to extract PageLinks that are not '#'
  }
  extractPageLinks(data: any): string[] {
    const pageLinks: string[] = [];
    if (data) {
      for (const menu of data) {
        for (const i of menu.Menus) {
            for (const subMenu of i.subMenus) {
              this.extractPageLinksRecursive(subMenu, pageLinks);
          }
        }
      }
    }

    return pageLinks;
  }

  extractPageLinksRecursive(menu: any, pageLinks: string[]) {
    if (menu.PageLink && menu.PageLink !== "#") {
      if(!!menu.PageLink.startsWith('/')) {
        pageLinks.push(menu.PageLink);
      } else {
        pageLinks.push('/' + menu.PageLink);
      }
      
    }

    if (menu.subMenus && menu.subMenus.length > 0) {
      for (const subMenu of menu.subMenus) {
        this.extractPageLinksRecursive(subMenu, pageLinks);
      }
    }
  }

  hasPermission(permission: string): boolean {
    // Allow visitor management routes
    if (permission.includes('visitor-management')) {
      return true;
    }
    
    const pages = JSON.parse(localStorage.getItem('pageLinks'));
    const parts = permission.split('/');
    const lastPart = parts[parts.length - 1];
    const isNumeric = /^\d+$/.test(lastPart);
    const cleanedUrl = isNumeric ? parts.slice(0, -1).join('/') : permission;
    
    let hasPermission = pages.includes(cleanedUrl);
    
    if (!hasPermission && cleanedUrl.startsWith('/contractor/')) {
      const urlWithoutModule = cleanedUrl.replace('/contractor', '');
      hasPermission = pages.includes(urlWithoutModule);
    }
    
    return hasPermission;
  }

  // Check if the user is authenticated
  isAuthenticatedUser() {
    this.isAuthenticated = localStorage.getItem('token') ? true : false;

    return this.isAuthenticated;
  }

  // Get user role from localStorage
  getUserRole(): number {
    const roleCode = localStorage.getItem('RoleCode');
    return roleCode ? parseInt(roleCode, 10) : null;
  }
}
